import { iconSizes } from '../../theme/tokens';
import { Box } from './Box';
import type { ReactNode } from 'react';

export type IconSize = keyof typeof iconSizes;

type IconProps = { size?: IconSize; children: ReactNode };

export const Icon = ({ size = 'md', children }: IconProps): JSX.Element => {
  const dimension = iconSizes[size];

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        width: dimension,
        height: dimension,
        '& svg': { width: '100%', height: '100%' },
      }}
    >
      {children}
    </Box>
  );
};
